













import { Component, Vue } from "vue-property-decorator";
import gql from "graphql-tag";
import SearchForm from "@/components/inputs/SearchForm.vue";
import SearchBuildingResult from "@/containers/SearchBuildingResult.vue";
import NoData from "@/basics/boxes/NoData.vue";

type BuildingFeed = {
  buildings: { token: string; name: string }[];
};

interface ResultPage {
  buildingFeed: BuildingFeed | null;
}

@Component({
  components: { SearchForm, SearchBuildingResult, NoData },
  apollo: {
    buildingFeed: {
      query: gql`
        query($count: Int!, $page: Int!, $query: String) {
          buildingFeed(count: $count, page: $page, query: $query) {
            buildings {
              id
              token
              name
              group {
                id
              }
            }
          }
        }
      `,
      variables() {
        const query = this.$_apollo.vm.$route.query;
        return {
          page: query.page || 1,
          count: 20,
          query: query.q || 1
        };
      }
    }
  }
})
export default class Result extends Vue implements ResultPage {
  value = "";

  beforeMount() {
    this.value = this.$route.query.q as string;
  }

  buildingFeed: BuildingFeed | null = null;

  get buildings() {
    if (!this.buildingFeed) {
      return [];
    }

    return this.buildingFeed!.buildings || [];
  }

  search(token: string) {
    if (token) {
      this.$router.push({ name: "search-result", query: { q: token } });
    }
  }
}
